import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthService } from '../shared/services/auth.service';
import { ApiService } from '../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DatosDenuncia } from 'src/app/shared/models/datosDenuncia';
import { PlazosDenuncia } from '../model/plazosDenuncia';
import { Historico } from '../model/historico';
import { environment } from "../../environments/environment.prod";
import { DatePipe } from '@angular/common';
import { Rol } from '../model/rol';
import { Usuarios } from '../dashboard/models/usuarios';

@Component({
  selector: 'app-enviar-denuncia-investigador',
  templateUrl: './enviar-denuncia-investigador.component.html',
  styleUrls: ['./enviar-denuncia-investigador.component.css'],
  providers: [DatePipe]
})
export class EnviarDenunciaInvestigadorComponent implements OnInit {
  assetsUrl: string = environment.baseAssetsUrl;
  historico: Historico[];
  validatingForm: FormGroup;
  IsHiddenForm: boolean = false;
  plazos: PlazosDenuncia[];
  roles: Rol[];
  isActiveIdPersonalizable: boolean = false; //Is Active Id Custom
  investigators: Usuarios[]
  @Input() denuncia: DatosDenuncia;
  @Input() deshabilitado: boolean = true;
  constructor(private apiService: ApiService, private auth: AuthService, private router: Router, private toastr: ToastrService, private translate: TranslateService, private datepipe: DatePipe) { }

  ngOnInit(): void {
    let language = this.auth.getLanguage();
    if (language == "" || language == null) {
      language = 'es';
    }
    this.translate.setDefaultLang(language);
    this.validatingForm = new FormGroup({
      enviarDenuncia: new FormControl('', [])
    });

    this.setupPersonalizable();
  }
  get enviarDenuncia() {
    return this.validatingForm.get('enviarDenuncia');
  }


  /** Send complaint to investigator */
  sendToInvestigator() {
    if (this.enviarDenuncia.value == true) {
      this.checkIfInvestigatorsAssigned().then(hasInvestigators => {
        if (!hasInvestigators) {
          this.toastr.error(this.translate.instant('texto_275'), this.translate.instant('texto_170'));
          return;
        }

        this.apiService.searchInvestigatorByIdDenuncia(this.denuncia[0].id_denuncia, '2').subscribe((investigator: PlazosDenuncia[]) => {
          this.plazos = investigator;
          if (this.plazos.length > 0) {
            this.handlePlazos(this.plazos);
          } else {
            this.toastr.error(this.translate.instant('texto_275'), this.translate.instant('texto_170'));
          }
        });

      });
    }

  }

  /** Extracted: set the personalizable-id flag. */
  private setupPersonalizable(): void {
    if (this.auth.getIdPersonalizable() == '1') {
      this.isActiveIdPersonalizable = true;
    }
  }

  /** Handle assigning users, sending emails and redirecting after updating phase. */
  private handlePlazos(plazos: PlazosDenuncia[]): void {
    this.apiService.updateComplaintById(this.denuncia[0].id_denuncia, '2', this.auth.getSociedad(), '', '').subscribe(res => {
      if (res == 200) {
        for (let i = 0; i < plazos.length; i++) {
          const p = plazos[i];
          // assign user to complaint
          this.apiService.createUserByIdComplaint(this.auth.getSociedad(), p.id_usuario, this.denuncia[0].id_denuncia, '2', '1', '1', false).subscribe();

          // prepare email
          const clausulas = this.getClausulasFlag();
          const plazoDays = Number(plazos[0].plazo_investigacion);
          const fecha = new Date();
          fecha.setDate(fecha.getDate() + plazoDays);
          const _date = this.datepipe.transform(fecha, 'dd-MM-yyyy');
          const url = environment.base + '/editar-denuncia/' + this.denuncia[0].id_denuncia;
          const idShown = this.getIdDenunciaShown();
          const message = this.translate.instant('texto_576') + ' ' + p.mail_user + this.translate.instant('texto_592') + ' ' + idShown + ' ' + this.translate.instant('texto_614') + ' ' + _date;

          this.apiService.sendEmail(p.mail_user, this.translate.instant('texto_594') + ' ' + idShown, message, url, clausulas, this.translate.instant('texto_615'), 'gestor').subscribe(res => {
            if (res == 200) {
              this.toastr.success(this.translate.instant('texto_273'), this.translate.instant('texto_274'));
            } else {
              this.toastr.error(this.translate.instant('texto_193'), this.translate.instant('texto_195'));
            }
          });

          // notify complainant once
          if (i == 0 && this.denuncia[0].denunciante_correo) {
            const urlComplainant = environment.base + '/#/ver-denuncia/consultar-denuncia';
            const messageC = this.translate.instant('texto_576') + ' ' + this.denuncia[0].denunciante_nombre + ' ' + this.denuncia[0].denunciante_apellidos + this.translate.instant('texto_604') + ' ' + idShown + ' ' + this.translate.instant('texto_616');
            this.apiService.sendEmail(this.denuncia[0].denunciante_correo, this.translate.instant('texto_594') + ' ' + idShown, messageC, urlComplainant, clausulas, this.translate.instant('texto_598'), 'gestor').subscribe(res => {
              if (res == 200) {
                this.toastr.success(this.translate.instant('texto_194'), this.translate.instant('texto_195'));
              } else {
                this.toastr.error(this.translate.instant('texto_193'), this.translate.instant('texto_195'));
              }
            }
            );
          }
        }

        // redirect depending on roles
        this.redirectAfterAssign();
      }
    });
  }

  /** Return the complaint identifier to show (personalizable if active). */
  private getIdDenunciaShown(): string {
    return this.isActiveIdPersonalizable
      ? (this.denuncia[0].identificador_denuncia || this.denuncia[0].id_denuncia)
      : this.denuncia[0].id_denuncia;
  }

  /** Read clausulas flag from localStorage. */
  private getClausulasFlag(): boolean {
    return localStorage.getItem('clausulas_correo') === '1';
  }

  /** Determine roles and redirect the user appropriately after assignment. */
  private redirectAfterAssign(): void {
    this.apiService.searchRoleByUserSociety('setUser', this.auth.getSociedad(), '1').subscribe({
      next: (roles) => {
        if (roles.success && roles.code === 200) {
          this.roles = roles.data;
          const roleList = this.roles.map(r => r.id_rol).join(',');
          const isInvestigator = roleList.includes('2');
          const isOwner = this.plazos[0].id_usuario == this.auth.getIdUser();

          const route = (isInvestigator && isOwner)
            ? ['editar-denuncia/', this.denuncia[0].id_denuncia]
            : ['dashboard/complaint-management/mis-denuncias'];

          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => this.router.navigate(route));
        }
      },
      error: () => {
        this.toastr.error(this.translate.instant('texto_915'), this.translate.instant('texto_813'));
      }
    });
  }

  /** Check whether there are investigators assigned to the complaint. */
  checkIfInvestigatorsAssigned(): Promise<boolean> {
    return new Promise((resolve) => {
      this.apiService.searchInvesSelect(this.auth.getSociedad(), this.denuncia[0].id_denuncia, "2").subscribe({
        next: (response) => {
          this.investigators = response?.data || [];
          resolve(this.investigators.length > 0);
        },
        error: (err) => {
          resolve(false);
        }
      });
    });
  }

}
